import { ConnectSuite } from './connect-suite.type';
import MemberInfo = ConnectSuite.MemberInfo;
import { LastNameSuffix } from '@aaa/interface-joinRenew-membership-membershipConnectSuite';
import { AccountDetails, MembershipAssociateDetails } from '@aaa/emember/store-types';
import { ClubApp } from '@aaa/emember/types';
import { environment } from '../../environments/environment';
import { getMembershipBlankCard } from '../modules/share/constants/membership-cards';
import { isStringEqual } from './utils/is-string-equal';
import { getFeatureFlagStateByClubId } from './feature-flags';
import { FeatureName } from './feature-flags/types';

export type PhoneType = 'cell' | 'home' | 'business';

export type AccountPhone = { [key in PhoneType]: string };

export type AccountAddress = {
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
};

export const getConnectsuiteAccountAddress = (memberInfo?: MemberInfo): AccountAddress => {
  return {
    street1: memberInfo?.membership.address.attributes.address1 || '',
    street2: memberInfo?.membership.address.attributes.address2 || '',
    city: memberInfo?.membership.address.attributes.cityName || '',
    state: memberInfo?.membership.address.attributes.StateProv || '',
    zip: memberInfo?.membership.address.attributes.postalCode || '',
  };
};

export const getConnectsuiteAccountPhone = (memberInfo?: MemberInfo): AccountPhone => {
  return {
    cell: memberInfo?.membership.primaryMember.attributes.cellPhone || '',
    home: memberInfo?.membership.primaryMember.attributes.homePhone || '',
    business: memberInfo?.membership.primaryMember.attributes.businessPhone || '',
  };
};

export const getConnectsuiteMembershipAssociates = (memberInfo?: MemberInfo): MembershipAssociateDetails[] => {
  return (memberInfo?.membership.associateMember || []).map((associate) => {
    return {
      dob: associate.attributes.dob,
      email: associate.attributes.email || '',
      firstName: associate.attributes.firstName,
      lastName: associate.attributes.lastName,
      membershipNumber: associate.attributes.membershipNumber,
      middleIntial: associate.attributes.middleIntial,
      nameSuffix: associate.attributes.nameSuffix as LastNameSuffix,
      removeAssociate: false,
      status: 'active',
      // Todo
      offerItems: [],
    };
  });
};

export const getMembershipCardLevel = (membershipLabel: string, accountDetails: AccountDetails | null) => {
  let programCode = '';
  const flags = getFeatureFlagStateByClubId(environment);
  const isEnabledEaglesMvpCard = flags.find((flag) => flag.name === FeatureName.EAGLES_MVP_PROGRAM);

  if ([ClubApp.Northampton].includes(environment.clubId) && isEnabledEaglesMvpCard?.active && accountDetails) {
    const mvpProgram = accountDetails.programs.find((program) => program.code === 'mvp');

    if (mvpProgram) {
      programCode = mvpProgram.code;
    }
  }

  const membershipCards = getMembershipBlankCard(environment, programCode);
  const membershipCard = membershipCards.find((m) => isStringEqual(m.membershipLabel, membershipLabel));

  return membershipCard || null;
};
